import Headroom from 'headroom.js'

export default () => {
  const header = document.querySelector('header')

  const headroom = new Headroom(header, {
    offset: 30,
    tolerance: {
      down: 0,
      up: 100,
    },
  })
  headroom.init()
}
